<template>
    <Overlay
        ref="modal"
        :propsData="{
            id: 'modal-filters',
            headingId: 'modal-filters-heading',
            reducedHeadingSpace: false
        }"
    >
        <template
            #Heading
        >
            <div>
                <h2
                    id="modal-filters-heading"
                    class="sub-heading text-primary"
                >
                    {{ $root.config.translations.filters.overlay_title }}
                </h2>
                <div v-if="productCount" class="body-r mt-[0.125rem]">
                    {{ productCount }}
                </div>
            </div>
        </template>
        <template
            #Content
        >
            <form
                ref="filterForm"
                @change.prevent="filterChange"
                @submit.prevent="filterChange"
                class="border-t border-uiMidGrey"
            >
                <!--
                    Bottle material
                -->
                <FilterOption
                    v-if="formData.bottleMaterial.length >= 1"
                    :filterData="formData.bottleMaterial"
                    :filterId="'Bottle-Material'"
                    :filterTranslation="$root.config.translations.filters.bottle_material"
                    :filterType="'bottleMaterial'"
                />

                <!--
                    Category
                -->
                <FilterOption
                    v-if="formData.category.length >= 1"
                    :filterData="formData.category"
                    :filterId="'Category'"
                    :filterTranslation="$root.config.translations.filters.category"
                    :filterType="'category'"
                />

                <!--
                    Certification and standards
                -->
                <FilterOption
                    v-if="formData.certificationAndStandards.length >= 1"
                    :filterData="formData.certificationAndStandards"
                    :filterId="'Certification-And-Standards'"
                    :filterTranslation="$root.config.translations.filters.certification_and_standards"
                    :filterType="'certificationAndStandards'"
                />

                <!--
                    Flow rate
                -->
                <FilterOption
                    v-if="formData.flowRate.length >= 1"
                    :filterData="formData.flowRate"
                    :filterId="'Flow-Rate'"
                    :filterTranslation="$root.config.translations.filters.flow_rate"
                    :filterType="'flowRate'"
                />

                <!--
                    Formula level
                -->
                <FilterOption
                    v-if="formData.formulaLevel.length >= 1"
                    :filterData="formData.formulaLevel"
                    :filterId="'Formula-Level'"
                    :filterTranslation="$root.config.translations.filters.formula_level"
                    :filterType="'formulaLevel'"
                />

                <!--
                    Infant age
                -->
                <FilterOption
                    v-if="formData.infantAge.length >= 1"
                    :filterData="formData.infantAge"
                    :filterId="'Infant-Age'"
                    :filterTranslation="$root.config.translations.filters.infant_age"
                    :filterType="'infantAge'"
                />

                <!--
                    Material
                -->
                <FilterOption
                    v-if="formData.material.length >= 1"
                    :filterData="formData.material"
                    :filterId="'Material'"
                    :filterTranslation="$root.config.translations.filters.material"
                    :filterType="'material'"
                />

                <!--
                    Milk type
                -->
                <FilterOption
                    v-if="formData.milkType.length >= 1"
                    :filterData="formData.milkType"
                    :filterId="'Milk-Type'"
                    :filterTranslation="$root.config.translations.filters.milk_type"
                    :filterType="'milkType'"
                />

                <!--
                    Nipple type
                -->
                <FilterOption
                    v-if="formData.nippleType.length >= 1"
                    :filterData="formData.nippleType"
                    :filterId="'Nipple-Type'"
                    :filterTranslation="$root.config.translations.filters.nipple_type"
                    :filterType="'nippleType'"
                />

                <!--
                    Pacifier design
                -->
                <FilterOption
                    v-if="formData.pacifierDesign.length >= 1"
                    :filterData="formData.pacifierDesign"
                    :filterId="'Pacifier-Design'"
                    :filterTranslation="$root.config.translations.filters.pacifier_design"
                    :filterType="'pacifierDesign'"
                />
            </form>
        </template>
        <template
            #Footer="footerProps"
        >
            <div class="sticky z-1 left-0 -bottom-14 py-[0.875rem] px-8 border-t border-uiMidGrey bg-uiWhite -mb-14 medium:py-5">
                <div class="flex items-center justify-between">
                    <button
                        type="button"
                        class="link font-bold body-m text-primary"
                        @click="clearFilters()"
                    >
                        {{ $root.config.translations.filters.clear_all_cta }}
                    </button>
                    <button
                        type="button"
                        class="button button--primary min-w-[10.875rem] justify-center"
                        @click="footerProps.closeDialog()"
                    >
                        {{ $root.config.translations.filters.apply_cta }}
                    </button>
                </div>
            </div>
        </template>
    </Overlay>
</template>

<script>
    import FilterOption from '@/apps/bundle-builder/components/FilterOption.vue';
    import Overlay from '@/apps/bundle-builder/components/Overlay.vue';

    export default {
        components: {
            FilterOption,
            Overlay
        },
        emits: [
            'form-change',
            'form-reset',
        ],
        props: {
            activeVendor: {
                type: String,
                default() {
                    return '';
                }
            },
            productCount: {
                type: String,
                default() {
                    return '';
                }
            },
            products: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data () {
            return {
                formData: {
                    bottleMaterial: [],
                    category: [],
                    certificationAndStandards: [],
                    flowRate: [],
                    formulaLevel: [],
                    infantAge: [],
                    material: [],
                    milkType: [],
                    nippleType: [],
                    pacifierDesign: []
                }
            }
        },
        mounted () {
            this.renderFilters();
        },
        watch: {
            activeVendor (newVendor, oldVendor) {
                if (newVendor != oldVendor) {
                    this.resetFilters();
                }
            },
            products (newProducts, oldProducts) {
                if (newProducts != oldProducts) {
                    this.renderFilters();
                    this.updateFilters();
                }
            }
        },
        methods: {
            clearFilters () {
                this.$emit('form-reset');
            },
            filterChange (e) {
                this.$emit('form-change', e.target.dataset.label, e.target.dataset.type, e.target.checked);
            },
            formatLabel (label) {
                return label.toLowerCase().replaceAll(' ', '_');
            },
            renderFilters () {
                this.products.forEach(product => {
                    if (product.filters) {
                        if (product.filters.bottleMaterial && product.filters.bottleMaterial.length > 0) {
                            this.renderFilter(this.formData.bottleMaterial, product.filters.bottleMaterial);
                        }

                        if (product.filters.category && product.filters.category.length > 0) {
                            this.renderFilter(this.formData.category, product.filters.category);
                        }

                        if (product.filters.certificationAndStandards && product.filters.certificationAndStandards.length > 0) {
                            this.renderFilter(this.formData.certificationAndStandards, product.filters.certificationAndStandards);
                        }

                        if (product.filters.flowRate && product.filters.flowRate.length > 0) {
                            this.renderFilter(this.formData.flowRate, product.filters.flowRate);
                        }

                        if (product.filters.formulaLevel && product.filters.formulaLevel.length > 0) {
                            this.renderFilter(this.formData.formulaLevel, product.filters.formulaLevel);
                        }

                        if (product.filters.infantAge && product.filters.infantAge.length > 0) {
                            this.renderFilter(this.formData.infantAge, product.filters.infantAge);
                        }

                        if (product.filters.material && product.filters.material.length > 0) {
                            this.renderFilter(this.formData.material, product.filters.material);
                        }

                        if (product.filters.milkType && product.filters.milkType.length > 0) {
                            this.renderFilter(this.formData.milkType, product.filters.milkType);
                        }

                        if (product.filters.nippleType && product.filters.nippleType.length > 0) {
                            this.renderFilter(this.formData.nippleType, product.filters.nippleType);
                        }

                        if (product.filters.pacifierDesign && product.filters.pacifierDesign.length > 0) {
                            this.renderFilter(this.formData.pacifierDesign, product.filters.pacifierDesign);
                        }
                    }
                });
            },
            renderFilter (formDataFilter, filters) {
                if (formDataFilter && filters) {
                    filters.forEach(filter => {
                        const currentFilter = formDataFilter.find((item) => item.label === filter);
                        if (!currentFilter) {
                            formDataFilter.push(
                                {
                                    label: filter,
                                    value: this.formatLabel(filter),
                                    count: 1,
                                    checked: false
                                }
                            );
                        } else {
                            currentFilter.count += 1;
                        }
                    });
                } else {
                    formDataFilter = [];
                }
            },
            resetFilters () {
                Object.keys(this.formData).forEach(filterKey => {
                    this.formData[filterKey] = [];
                });
            },
            updateFilters () {
                this.formData.bottleMaterial.forEach(bottleMaterial => {
                    bottleMaterial.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.bottleMaterial.includes(bottleMaterial.label)) {
                            bottleMaterial.count += 1;
                        }
                    });
                });

                this.formData.category.forEach(category => {
                    category.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.category.includes(category.label)) {
                            category.count += 1;
                        }
                    });
                });

                this.formData.certificationAndStandards.forEach(certificationAndStandards => {
                    certificationAndStandards.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.certificationAndStandards.includes(certificationAndStandards.label)) {
                            certificationAndStandards.count += 1;
                        }
                    });
                });

                this.formData.flowRate.forEach(flowRate => {
                    flowRate.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.flowRate.includes(flowRate.label)) {
                            flowRate.count += 1;
                        }
                    });
                });

                this.formData.formulaLevel.forEach(formulaLevel => {
                    formulaLevel.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.formulaLevel.includes(formulaLevel.label)) {
                            formulaLevel.count += 1;
                        }
                    });
                });

                this.formData.infantAge.forEach(infantAge => {
                    infantAge.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.infantAge.includes(infantAge.label)) {
                            infantAge.count += 1;
                        }
                    });
                });


                this.formData.material.forEach(material => {
                    material.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.material.includes(material.label)) {
                            material.count += 1;
                        }
                    });
                });

                this.formData.milkType.forEach(milkType => {
                    milkType.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.milkType.includes(milkType.label)) {
                            milkType.count += 1;
                        }
                    });
                });

                this.formData.nippleType.forEach(nippleType => {
                    nippleType.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.nippleType.includes(nippleType.label)) {
                            nippleType.count += 1;
                        }
                    });
                });

                this.formData.pacifierDesign.forEach(pacifierDesign => {
                    pacifierDesign.count = 0;

                    this.products.forEach(product => {
                        if (product.filters.pacifierDesign.includes(pacifierDesign.label)) {
                            pacifierDesign.count += 1;
                        }
                    });
                });
            }
        }
    }
</script>
